import { z } from 'zod';

export const MetricComputationJobSchema = z.object({
  kind: z.enum(['current', 'settlement']),
  metricId: z.string().min(1),
  periodStart: z.string().datetime(),
  periodEnd: z.string().datetime(),
  granularity: z.enum(['hourly', 'daily', 'weekly', 'monthly']),
  enqueuedAt: z.string().datetime(),
  tickId: z.string().uuid(),
});

export type MetricComputationJob = z.infer<typeof MetricComputationJobSchema>;
